/*
    The dataRequest for the data modules being consumed here are made in PayrollInstructionsFlowContainer
*/
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { analyticsPaymentSetupHelpOpen } from '@perpay-web/fintech/actions/analytics/paymentSetupHelp';
import { createEvent } from '@perpay-web/fintech/actions/entities/events';
import { analyticsPayrollInstructionsFinishClicked } from '@perpay-web/fintech/actions/entities/instructions';
import PayrollInstructions from '@perpay-web/fintech/components/composite/PayrollInstructions/PayrollInstructions';
import { PAYROLL_INSTRUCTIONS_FINISHED } from '@perpay-web/fintech/constants/eventTypes';
import {
    getIsCompanyUnverified,
    getUserIsInboundPhoneTestEligible,
} from '@perpay-web/fintech/dataModules/composed/payrollInstructionsFlow';
import {
    getCompanyFormEnabled,
    getDirectDepositFormUrl,
    getIsCompanyOther,
    getOtherCompanyInstructionsAccordionHeading,
    getOtherCompanyInstructionsAccordionHTML,
    getOtherCompanyPayrollInstructions,
    getPayrollProviderInstructions,
    getPayrollWorksWithPerpay,
} from '@perpay-web/fintech/dataModules/fetchPayrollInstructions';
import { launchSupportTool } from '@perpay-web/services/supportTool';

const PayrollInstructionsContainer = ({
    instructionsType,
    closeWhenSupportToolLaunched,
    onClickFinished: ownPropsOnClickFinished,
    onClickNeedHelp: ownPropsOnClickNeedHelp,
    flowType = null,
}) => {
    const dispatch = useDispatch();
    const companyIsOther = useSelector(getIsCompanyOther);
    const inboundPhoneTestEligible = useSelector(
        getUserIsInboundPhoneTestEligible,
    );
    const companyFormEnabled = useSelector(getCompanyFormEnabled);
    const directDepositFormUrl = useSelector(getDirectDepositFormUrl);
    const otherInstructionsAccordionHTML = useSelector(
        getOtherCompanyInstructionsAccordionHTML,
    );
    const otherInstructionsAccordionHeading = useSelector(
        getOtherCompanyInstructionsAccordionHeading,
    );
    const otherCompanyPayrollInstructions = useSelector(
        getOtherCompanyPayrollInstructions,
    );
    const payrollProviderInstructions = useSelector(
        getPayrollProviderInstructions,
    );
    const payrollWorksWithPerpay = useSelector(getPayrollWorksWithPerpay);
    const isCompanyUnverified = useSelector(getIsCompanyUnverified);

    const worksForVerifiedCompany = !isCompanyUnverified;

    const launchSelfHelpToolHandler = useCallback(() => {
        dispatch(launchSupportTool());

        if (closeWhenSupportToolLaunched) {
            ownPropsOnClickFinished();
        }
    }, [closeWhenSupportToolLaunched, dispatch, ownPropsOnClickFinished]);

    const onClickFinished = useCallback(() => {
        dispatch(createEvent(PAYROLL_INSTRUCTIONS_FINISHED));
        const additionalProperties = flowType ? { flow_type: flowType } : {};
        dispatch(
            analyticsPayrollInstructionsFinishClicked(
                instructionsType,
                additionalProperties,
            ),
        );
        ownPropsOnClickFinished();
    }, [dispatch, instructionsType, ownPropsOnClickFinished, flowType]);

    const onClickNeedHelp = useCallback(() => {
        dispatch(analyticsPaymentSetupHelpOpen());
        ownPropsOnClickNeedHelp();
    }, [dispatch, ownPropsOnClickNeedHelp]);

    return (
        <PayrollInstructions
            companyIsOther={companyIsOther}
            inboundPhoneTestEligible={inboundPhoneTestEligible}
            instructionsType={instructionsType}
            launchSelfHelpToolHandler={launchSelfHelpToolHandler}
            onClickFinished={onClickFinished}
            onClickNeedHelp={onClickNeedHelp}
            otherCompanyPayrollInstructions={otherCompanyPayrollInstructions}
            worksForVerifiedCompany={worksForVerifiedCompany}
            companyFormEnabled={companyFormEnabled}
            directDepositFormUrl={directDepositFormUrl}
            otherInstructionsAccordionHTML={otherInstructionsAccordionHTML}
            otherInstructionsAccordionHeading={
                otherInstructionsAccordionHeading
            }
            payrollProviderInstructions={payrollProviderInstructions}
            payrollWorksWithPerpay={payrollWorksWithPerpay}
        />
    );
};

export default PayrollInstructionsContainer;
